// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1_yRh","select":"styles_select__2Uqsa"};